import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Chip,
  Avatar,
  Divider,
} from "@mui/material";
import StarsIcon from "@mui/icons-material/Stars";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const EarnPoints = () => {
  const steps = [
    {
      icon: <ThumbUpAltOutlinedIcon />,
      title: "Rate items",
      detail: "Every rating gives base points. Stay active to keep earning.",
      badge: "Live",
    },
    {
      icon: <InsightsOutlinedIcon />,
      title: "Add quality insights",
      detail: "Thoughtful notes and clear rationale earn more points per rate.",
      badge: "Quality bonus",
    },
    {
      icon: <TrendingUpIcon />,
      title: "Keep a streak",
      detail: "Consistent, helpful ratings across the week boost your rewards.",
      badge: "Streak bonus",
    },
  ];

  const comingSoon = [
    "Points when others comment on your rates.",
    "Extra points when your rate is marked helpful."
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: "auto" }}>
      <Card
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 3,
          background: "linear-gradient(135deg, #0ea5e9, #7c3aed)",
          color: "#fff",
          boxShadow: "0 22px 48px rgba(99,102,241,0.25)",
        }}
      >
        <CardContent>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
          >
            <Stack spacing={1}>
              <Typography variant="overline" sx={{ letterSpacing: 1, opacity: 0.9 }}>
                How to earn points
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                Earn by rating items with quality insights
              </Typography>
              <Typography variant="body1" sx={{ maxWidth: 620, opacity: 0.92 }}>
                Points are awarded when you rate items. Clear, helpful notes give you
                more points per rate. Keep a consistent streak to maximize rewards.
              </Typography>
            </Stack>

          </Stack>
        </CardContent>
      </Card>

      <Grid container spacing={3}>
        {steps.map((step) => (
          <Grid item xs={12} md={4} key={step.title}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                borderRadius: 3,
                border: "1px solid rgba(226,232,240,0.8)",
                boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
              }}
            >
              <CardContent>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
                  <Avatar
                    sx={{
                      bgcolor: "rgba(99,102,241,0.12)",
                      color: "#6366f1",
                    }}
                  >
                    {step.icon}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      {step.title}
                    </Typography>
                    <Chip size="small" label={step.badge} color="primary" variant="outlined" />
                  </Box>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  {step.detail}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card
        elevation={0}
        sx={{
          mt: 3,
          borderRadius: 3,
          border: "1px solid rgba(226,232,240,0.8)",
          boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
        }}
      >
        <CardContent>
          <Stack spacing={1.5}>
            <Typography variant="subtitle2" color="text.secondary">
              Coming soon
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              More ways to earn
            </Typography>
            <Stack spacing={1}>
              {comingSoon.map((line) => (
                <Stack direction="row" spacing={1} alignItems="flex-start" key={line}>
                  <MessageOutlinedIcon fontSize="small" sx={{ color: "rgb(0,202,153)", mt: 0.3 }} />
                  <Typography variant="body2" color="text.secondary">
                    {line}
                  </Typography>
                </Stack>
              ))}
            </Stack>

          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EarnPoints;

